export default "__VITE_ASSET__DxZlmu3R__"